import React from 'react'
import { useDropzone } from 'react-dropzone'

const styles = {
  dropzone: {
    width: '40%',
    height: 90,
    borderWidth: 2,
    borderColor: '#666',
    borderStyle: 'dashed',
    borderRadius: 5,
    padding: '0 20px',
    margin: '20px',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },

  dropzoneError: {
    order: 100,
    fontSize: 12,
    lineHeight: '12px',
    color: 'rgb(244, 67, 54)',
    width: '100%',
  },
}
export const renderDropzoneField = (data: any) => {
  const {
    input,
    meta: { dirty, error },
  } = data
  const convertTypePreview = (file: File) =>
    Object.assign(file, {
      preview: URL.createObjectURL(file),
    })
  const onDrop = (acceptedFiles: File[]) =>
    input.onDrop(convertTypePreview(acceptedFiles[0]))
  const onDropAccepted = (files: File[]) =>
    input.onChange(convertTypePreview(files[0]))

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: {
      'image/*': [] // 画像ファイルのみ許可
    },
    onDrop,
    onDropAccepted,
    multiple: false, // 複数ファイルの選択を禁止
    maxFiles: 1,      // 念のため明示的に最大1個に制限
  })

  return (
    <div>
      <div {...getRootProps()} style={styles.dropzone}>
        <input {...getInputProps()} />
        {isDragActive ? (
          <p> ファイルをこちらにドロップするとアップロードされます。</p>
        ) : (
          <p>
            ファイルをドロップするかクリックしてファイルを選択するとアップロードされます。
          </p>
        )}
      </div>
      {dirty && error && <span style={styles.dropzoneError}>{error}</span>}
    </div>
  )
}

export const ImageDropzone = ({ onDrop, style }: any) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false, // 複数ファイルの選択を禁止
    maxFiles: 1,      // 念のため明示的に最大1個に制限
    accept: {
      'image/*': [] // 画像ファイルのみ許可
    },

  })

  return (
    <div>
      <div {...getRootProps()} style={style}>
        <input {...getInputProps()} />
        {isDragActive ? (
          <p>
            ファイルをこちらにドロップするとアップロードされます。
          </p>
        ) : (
          <p>
            ファイルをドロップするかクリックしてファイルを選択するとアップロードされます。
          </p>
        )}
      </div>
    </div>
  )
}
